import { FC } from 'react';
import { Link } from './Link';
import { useTemplateStore } from '../DashboardViewer/hooks/TemplateProvider';
import { buildObserveUrl } from '../../../utils';
import { pick } from 'lodash';
import { format } from 'url';

export interface ECPLinkRendererProps {
  id: string; // URN RFC 2141 format, e.g. "aws:ec2:gjVP0Xp8Pjuih/TmIcv5gQ"
  value: string;
  openInNewTab?: boolean;
}

/**
 * This component renders an entity detail link
 */
// todo: consolidate link components if possible
export const ECPLinkRenderer: FC<ECPLinkRendererProps> = ({ id, value, openInNewTab = false }) => {
  const [globals] = useTemplateStore((store: unknown) => (store as Record<string, unknown>).globals);
  const timerange = pick((globals as Record<string, unknown>).variables, ['since', 'until']);
  const href = format(buildObserveUrl(id, timerange));

  return (
    <Link href={href} target={openInNewTab ? '_blank' : '_self'}>
      {value}
    </Link>
  );
};
